export const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column'
    }
};
